import React, { useRef } from 'react';
import { Center, Text, Image } from '@mantine/core';
import { Blip } from '../Features/Radar';
import { getLogoUrl } from '../Features/Technology/shared';

interface TooltipProps {
  blip: Blip;
  scale: number;
}

function Tooltip({ blip, scale }: TooltipProps) {
  const canvas = useRef<HTMLCanvasElement | null>(null);

  function getTextWidth(text: string) {
    let canvasElement;
    if (canvas.current) {
      canvasElement = canvas.current;
    } else {
      canvasElement = document.createElement('canvas');
      canvas.current = canvasElement;
    }
    const context = canvas.current.getContext('2d');
    if (context) {
      context.font = '16px Roboto';
    }
    const metrics = context?.measureText(text);
    return metrics?.width;
  }

  const textWidth = getTextWidth(blip.name) ?? 0;
  const logoWidth = blip.logoUrl ? 24 : 0;

  return (
    <div
      style={{
        position: 'absolute',
        backgroundColor: 'white',
        color: 'black',
        fontSize: 16,
        padding: '6px 12px',
        border: '1px solid black',
        borderRadius: 4,
        top: blip.y * scale - 50 * scale,
        left: blip.x * scale - textWidth / 2 - logoWidth / 2 - 12,
        whiteSpace: 'nowrap',
      }}
    >
      <Center>
        {blip.logoUrl && <Image src={getLogoUrl(blip.logoUrl)} width={24} height={24} fit={'contain'} />}
        <Text ml={blip.logoUrl ? 'xs' : 0}>{blip?.name}</Text>
      </Center>
    </div>
  );
}

export default Tooltip;
